import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "toolbar", "count"];
  static values = { apiUrl: String };

  toggleAll(event) {
    const checked = event.target.checked;
    this.checkboxTargets.forEach((cb) => (cb.checked = checked));
    this.#updateToolbar();
  }

  onCheckboxChange() {
    this.#updateToolbar();
  }

  markDone() {
    this.#submitOperation("done");
  }

  defer() {
    this.#submitOperation("defer");
  }

  bulkDelete() {
    if (!confirm("Delete selected captures?")) return;
    this.#submitOperation("delete");
  }

  #selectedIds() {
    return this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.dataset.captureId);
  }

  #updateToolbar() {
    const count = this.#selectedIds().length;
    if (this.hasToolbarTarget) {
      this.toolbarTarget.classList.toggle("hidden", count === 0);
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = count;
    }
    if (this.hasSelectAllTarget) {
      const total = this.checkboxTargets.length;
      this.selectAllTarget.indeterminate = count > 0 && count < total;
      this.selectAllTarget.checked = count > 0 && count === total;
    }
  }

  async #submitOperation(operation) {
    const ids = this.#selectedIds();
    if (ids.length === 0) return;

    try {
      const response = await fetch(this.apiUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
            ?.content,
        },
        body: JSON.stringify({ ids, operation }),
      });

      if (response.ok) {
        this.checkboxTargets
          .filter((cb) => cb.checked)
          .forEach((cb) => {
            const card = cb.closest(".capture-card");
            if (card) card.remove();
          });
        this.#updateToolbar();
      } else {
        alert("Something went wrong. Please refresh and try again.");
      }
    } catch {
      alert("Network error. Please check your connection and try again.");
    }
  }
}
